import { render } from "./organize.vue?vue&type=template&id=087b1ba9"
import script from "./organize.vue?vue&type=script&lang=js"
export * from "./organize.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__